<template>
  <v-card outlined class="pa-4 ma-0 d-flex flex-column" style="height: 390px">
    <!-- Header -->
    <v-container class="pa-0 pr-10 ma-0 d-flex flex-column gap-2 text-right rtl">
      <v-card-text class="pa-0 ma-0 text-body-1">
        {{ $t("cost_distribution") }}
      </v-card-text>
      <v-card-text class="pa-0 ma-0 text-body-2 gray--text" style="color: #717182">
        {{ $t("cost_distribution_subtitle") }}
      </v-card-text>
    </v-container>
    <!-- chart -->
    <v-container class="pa-0 ma-0">
      <apexchart
        v-if="hasData"
        type="donut"
        height="190"
        :series="series"
        :options="chartOptions"
      />
    </v-container>
    <!-- details -->

    <v-container v-if="hasData" class="pa-0 ma-0">
      <v-list dense class="pa-0 ma-0">
        <v-list-item
          v-for="(item, index) in suppliersWithPercent"
          :key="item.name"
          class="pa-0 ma-0"
        >
          <v-list-item-content>
            <v-container class="pa-0 ma-0 d-flex justify-space-between align-center">
              <v-container class="pa-0 ma-0 d-flex flex-column">
                <!-- title -->
                <v-container class="pa-0 ma-0 d-flex align-center">
                  <v-card-text
                    class="legend-dot pa-0 ma-0 ml-2"
                    :style="{ backgroundColor: colors[index] }"
                  >
                  </v-card-text>
                  <span class="body-2">
                    {{ item.name }}
                  </span>
                </v-container>
              </v-container>
              <v-container class="pa-0 ma-0 d-flex" style="width: auto">
                <v-card-text class="pa-0 ma-0 text-body-1">
                  {{ item.percent }}
                </v-card-text>
                <v-card-text class="pa-0 ma-0 text-body-2">%</v-card-text>
              </v-container>
            </v-container>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-container>
    <v-container
      v-if="!hasData"
      class="pa-0 ma-0 d-flex flex-column align-center justify-center"
      style="height: 337px"
    >
      <img
        :src="require('@/assets/dashboard/no-data(3).png')"
        max-width="100"
        height="100"
        contain
        class="mb-3"
      />
      <v-card-text class="text-body-2 grey--text text-center">
        {{ $t("nothing-for-render") }}
      </v-card-text>
    </v-container>
  </v-card>
</template>
<script>
export default {
  name: "SupplierCostDistribution",
  props: {
    filterChart: {
      type: Object,
      default: null,
    },
    advanceFilter: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      suppliers: [],
      colors: ["#3B82F6", "#10B981", "#F59E0B", "#8B5CF6", "#EF4444"],
      loading: false,
    };
  },
  computed: {
    hasData() {
      return this.series.some((val) => val > 0);
    },
    series() {
      return this.suppliers.map((item) => item.value);
    },
    totalValue() {
      return this.suppliers.reduce((sum, item) => sum + item.value, 0);
    },
    suppliersWithPercent() {
      if (!this.totalValue) return [];

      return this.suppliers.map((item) => ({
        ...item,
        percent: +((item.value / this.totalValue) * 100).toFixed(2),
      }));
    },
    chartOptions() {
      return {
        chart: {
          type: "donut",
          fontFamily: "IRANSans",
        },

        labels: this.suppliers.map((i) => i.name),
        colors: this.colors,
        legend: {
          show: false,
        },
        stroke: {
          show: true,
          width: 0,
          colors: ["#ffffff"],
        },
        dataLabels: {
          enabled: false,
          style: {
            fontSize: "12px",
            colors: [],
          },
        },
        plotOptions: {
          pie: {
            donut: {
              size: "70%",
            },
          },
        },

        tooltip: {
          y: {
            formatter: (value) => {
              return (
                value.toLocaleString("fa-IR") + " " + this.$store.state.currency.name
              );
            },
          },
        },
      };
    },
  },
  watch: {
    filterChart: {
      deep: true,
      handler(newVal) {
        this.getCostBycategory();
        newVal;
      },
    },
    advanceFilter: {
      deep: true,
      handler(newVal) {
        this.getCostBycategory(newVal);
      },
    },
  },
  mounted() {
    this.getCostBycategory();
  },
  methods: {
    getCostBycategory(filters = {}) {
      const hasDefaultDate = !!filters?.fromDate && !!filters?.toDate;
      const Type = hasDefaultDate ? false : "year";
      let UserList = [];
      let ProductList = [];
      if (
        filters.UserList != undefined &&
        filters.UserList != null &&
        filters.UserList != []
      ) {
        UserList = filters?.UserList.map((u) => u.id);
      }
      if (
        filters.products != undefined &&
        filters.products != null &&
        filters.products != []
      ) {
        ProductList = filters?.products.map((p) => p.id);
      }
      let app = this;
      this.loading = true;
      this.$axios
        .get(this.$endpoint + "dashboard/charts/cost-by-group", {
          params: {
            dateType: Type,
            fromDate: filters.fromDate || null,
            toDate: filters.toDate || null,
            status: filters.sellStatus || [],
            accountIds: filters.account || [],
            branch: filters.branch || [],
            UserList: UserList || [],
            minAmount: filters.amountRange?.[0] ?? null,
            maxAmount: filters.amountRange?.[1] ?? null,
            ProductList: ProductList || [],
            productGroup: filters.productGroup || null,
            entrepot: filters.entrepot || null,
            attachment: filters.attachments || null,
            receipt: filters.Receipt || null,
            category: filters.category || null,
            minAmountTax: filters.amountRangeTax?.[0] ?? null,
            maxAmountTax: filters.amountRangeTax?.[1] ?? null,
            invoice_status: filters.status || null,
          },
        })
        .then((response) => {
          let res = response.data.data.costByGroup || [];
          app.suppliers = res
            .map((item) => ({
              name: item.account_name,
              value: Math.abs(Number(item.current || 0)),
            }))
            .slice(-5);
        })
        .catch((error) => {
          console.error("compare sell and profit chart error:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatCurrency(value) {
      return value.toLocaleString("fa-IR");
    },
  },
};
</script>

<style scoped>
::v-deep .v-list--dense .v-list-item {
  min-height: 18px;
}
::v-deep .v-list-item__content {
  padding: 0px !important;
}
.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}
</style>
